module.exports = require("core-js/modules/es.array.every.js");